import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable, Page } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { entityAsideMenuKey, SiteHeaderLayout, SiteHeaderProvider, useTrends, useView } from '@shapeable/ui';
import { ExplorerEntityDetailsLayout, ExplorerEntityDetailsLayoutDefaultProps, ExplorerEntityDetailsLayoutProps, SliceLayoutBoundary } from '@shapeable/ui';
import { PageConversationsViewLayout } from './page-conversations-view-layout';
import { PageConversationsAsideLayout } from './page-conversations-aside-layout';
import { EntityConversationMobileHeader } from './entity-conversation-mobile-header';
const cls = classNames('page-conversations-layout');

// -------- Types -------->

// -------- Props -------->

export type PageConversationsLayoutProps = ExplorerEntityDetailsLayoutProps & { 
  entity: Page;
};

export const PageConversationsLayoutDefaultProps: Omit<PageConversationsLayoutProps, 'entity'> = {
  ...ExplorerEntityDetailsLayoutDefaultProps,
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  `,
});

const LayoutStyles = breakpoints({
  base: css`
    
  `,
  desktop: css`
    padding-top: ${theme.UNIT(6)};
  `
});

const HeaderStyles = breakpoints({
  base: css`
    
  `,
});

const PageViewStyles = breakpoints({
  base: css`
    
  `,
});

const AsideViewStyles = breakpoints({
  base: css`
    
  `,
});



// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Header: styled(SiteHeaderLayout)`${HeaderStyles}`,
    Layout: styled(ExplorerEntityDetailsLayout)`${LayoutStyles}`,
      MainView: styled(PageConversationsViewLayout)`${PageViewStyles}`,
      AsideView: styled(PageConversationsAsideLayout)`${AsideViewStyles}`,
};

export const PageConversationsLayout: Shapeable.FC<PageConversationsLayoutProps> = (props) => {
  const { className, children, entity } = props;

  // const trends = useTrends();

  // const items = [entity, ...trends];
  const items = [entity];

  const { activeSubView } = useView(entity?.slug, 'conversations', 'aside');
  const activeItem = items.find((item) => entityAsideMenuKey(item) === activeSubView);
  const isAside = activeSubView === 'aside';

  return (
    <SiteHeaderProvider value={{ 
      variant: 'default',
    }}>
    <My.Container>
      <My.Header variant="light" />
      <SliceLayoutBoundary boundary='none' >
      {
        !isAside && <EntityConversationMobileHeader entity={activeItem} />
      }
      <My.Layout 
        entity={entity}
        className={cls.name(className)}
        stickyTopOffset={64}
        asideMaxWidth={300}
        isAsideSticky={false}
        asideIsOffset={false}
        showAsideHeader={false}
        showSiteFooter={() => false}
        showBanner={false}
        showMetaHead={() => false}
        showAsideOnMobile={() => isAside}
        
        // main
        content={
          <My.MainView entity={entity} />
        }

        // // aside 
        metaHead={
          <My.AsideView entity={entity} />
        }
        
        />
        </SliceLayoutBoundary>
    </My.Container>
    </SiteHeaderProvider>
  )
};

PageConversationsLayout.defaultProps = PageConversationsLayoutDefaultProps;
PageConversationsLayout.cls = cls;